/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiExternalClickFromJSON, ApiExternalClickToJSON, } from './ApiExternalClick';
import { ApiOauthClientFromJSON, ApiOauthClientToJSON, } from './ApiOauthClient';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSyncStatusFromJSON, ApiSyncStatusToJSON, } from './ApiSyncStatus';
import { ApiSyncTypeFromJSON, ApiSyncTypeToJSON, } from './ApiSyncType';
export function ApiSyncFromJSON(json) {
    return ApiSyncFromJSONTyped(json, false);
}
export function ApiSyncFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'account': !exists(json, 'account') ? undefined : json['account'],
        'accountName': !exists(json, 'accountName') ? undefined : json['accountName'],
        'campaigns': !exists(json, 'campaigns') ? undefined : (json['campaigns'].map(ApiExternalCampaignFromJSON)),
        'campaignsCount': !exists(json, 'campaignsCount') ? undefined : json['campaignsCount'],
        'clicks': !exists(json, 'clicks') ? undefined : (json['clicks'].map(ApiExternalClickFromJSON)),
        'clicksCount': !exists(json, 'clicksCount') ? undefined : json['clicksCount'],
        'client': !exists(json, 'client') ? undefined : ApiOauthClientFromJSON(json['client']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'errorCount': !exists(json, 'errorCount') ? undefined : json['errorCount'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'oauthClientId': !exists(json, 'oauthClientId') ? undefined : json['oauthClientId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'status': !exists(json, 'status') ? undefined : ApiSyncStatusFromJSON(json['status']),
        'syncedAt': !exists(json, 'syncedAt') ? undefined : (new Date(json['syncedAt'])),
        'type': !exists(json, 'type') ? undefined : ApiSyncTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiSyncToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'account': value.account,
        'accountName': value.accountName,
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(ApiExternalCampaignToJSON)),
        'campaignsCount': value.campaignsCount,
        'clicks': value.clicks === undefined ? undefined : (value.clicks.map(ApiExternalClickToJSON)),
        'clicksCount': value.clicksCount,
        'client': ApiOauthClientToJSON(value.client),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'error': value.error,
        'errorCount': value.errorCount,
        'id': value.id,
        'oauthClientId': value.oauthClientId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'status': ApiSyncStatusToJSON(value.status),
        'syncedAt': value.syncedAt === undefined ? undefined : (value.syncedAt.toISOString()),
        'type': ApiSyncTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
